'use client';

import { useTranslations } from 'next-intl';
import React from 'react';

import { Typography } from '@/components/atoms';
import { LinkButton } from '@/components/molecules';
import { CarouselArt } from '@/components/organisms';

import type { GalleryCarouselProps } from '@/components/organisms';

export const GalleryCarousel: React.FC<GalleryCarouselProps> = ({
  items,
  carouselTitle,
  carouselDescription,
}) => {
  const t = useTranslations();

  return (
    <div className="w-full bg-white overflow-hidden px-6">
      {carouselTitle && (
        <div className="w-full py-3 flex flex-wrap justify-between items-center gap-2">
          <div className="">
            <Typography.Heading variant="h5" className="py-1">
              {carouselTitle}
            </Typography.Heading>
            <Typography.Text weight="regular" size="md" className="py-1">
              {carouselDescription}
            </Typography.Text>
          </div>
          {items[0] && (
            <LinkButton
              href={`/gallery/${items[0].id}`}
              variant={'primary'}
              className="pointer-events-auto rounded-full shadow-md"
            >
              {t('GALLERY_LAUNCH_SLIDESHOW')}
            </LinkButton>
          )}
        </div>
      )}
      <div className="flex gap-4 overflow-x-hidden py-4">
        <CarouselArt
          items={items}
          spaceBetween={10}
          effect={'default'}
          navigation={true}
          pagination={false}
          autoplay={false}
        />
      </div>
    </div>
  );
};
